import React from "react";

const CaseBlock = ({ data, isAltBackground }) => {
  const cbData = data.primary;
  const isRightAligned = cbData.image_orientation;
  const isAnchored = cbData.image_placement;
  const hasSecondary = !!cbData.secondary_image.url;
  const hasHorizontal = !!cbData.horizontal_image.url;
  const hasVertical = !!cbData.vertical_image.url;
  const onlyMain = !hasSecondary && !hasHorizontal && !hasVertical;

  const renderImages = () => {

    return (
      <div className="imageContainer">
        <div className={`mainImage ${onlyMain ? 'onlyMainImage' : ''}`}>
          <img src={cbData.main_image.url} alt={cbData.main_image.alt} />
          {hasSecondary && !isAnchored && (
            <div className="secondaryImage">
              <img src={cbData.secondary_image.url} alt={cbData.secondary_image.alt} />
            </div>
          )}
          {hasHorizontal && (
            <div className="horizontalImage">
              <img src={cbData.horizontal_image.url} alt={cbData.horizontal_image.alt} />
            </div>
          )}
          {hasVertical && isAnchored && (
            <div className="verticalImage">
              <img src={cbData.vertical_image.url} alt={cbData.vertical_image.alt} />
            </div>
          )}
        </div>
      </div>
    )
  }

  const renderTextBlock = () => {
    const logoBarColor = cbData.logo_bar_color || "#FFFFFF";

    return (
      <React.Fragment>
        <div className="cbLogoBar" style={{ backgroundColor: logoBarColor }}>
          {cbData.logo_image && (
            <div className="cbLogoWrapper">
              <img className="cbLogoImage" src={cbData.logo_image.url} alt={cbData.logo_image.alt} />
            </div>
          )}
          {cbData.logo_text && (
            <h3>{cbData.logo_text}</h3>
          )}
        </div>
        <div className="cbTextWrapper">
          {cbData.block_name && (
            <h3 className="cbTitle">
              {cbData.block_name}
            </h3>
          )}
          {cbData.block_type && (
            <p className="cbType">
              {cbData.block_type}
            </p>
          )}
          {cbData.block_description[0].text && (
            <p className="cbDescription">
              {cbData.block_description[0].text}
            </p>
          )}
        </div>
      </React.Fragment>
    )
  }

  return (
    <section className={`cbSection ${isAltBackground ? 'altBg' : ''}`}>
      <div className="cbWrapper">
        <div className={`cbLeft ${isRightAligned ? "textLeft" : "imageLeft"} ${isAnchored ? "anchored" : ""}`}>
          {isRightAligned ? renderTextBlock() : renderImages()}
        </div>
        <div className={`cbRight ${isRightAligned ? "imageRight" : "textRight"} ${isAnchored ? "anchored" : ""}`}>
          {isRightAligned ? renderImages() : renderTextBlock()}
        </div>
      </div>
    </section>
  )
}
export default CaseBlock;